import {WmWoundQuestion} from '../../interfaces/wound-management/wm-wound-question';
import {WmWoundAnswerOption} from '../../interfaces/wound-management/wm-wound-answer-option';
import {WmFormControlType} from '../../enums/wound-management/wm-form-control-type';
import {WmWoundQuestionType} from '../../enums/wound-management/wm-wound-question-type';
import {WmWoundAnswerOptionFactory} from './wm-wound-answer-option-factory';

export class WmWoundQuestionFactory {

  /**
   *
   * @param wmWoundQuestion
   */
  public static fromObject(wmWoundQuestion: any): WmWoundQuestion {
    return new class implements WmWoundQuestion {
      created: string = wmWoundQuestion.created;
      id: number = wmWoundQuestion.id;
      isMultipleChoice: boolean = wmWoundQuestion.is_multiple_choice;
      modified: string = wmWoundQuestion.modified;
      isRequired: boolean = wmWoundQuestion.is_required;
      name: string = wmWoundQuestion.name;
      type: WmWoundQuestionType = wmWoundQuestion.type;
      withCustomAnswer: boolean = wmWoundQuestion.with_custom_answer;
      wmFormControlType: WmFormControlType = wmWoundQuestion.form_control_type;
      wmWoundAnswerOptions: WmWoundAnswerOption[] = wmWoundQuestion.wm_wound_answer_options ?
        WmWoundAnswerOptionFactory.fromArray(wmWoundQuestion.wm_wound_answer_options) : [];
      size: number = wmWoundQuestion.size;
      sort: number = wmWoundQuestion.sort;
    };
  }

  /**
   *
   * @param wmWoundQuestions
   */
  public static fromArray(wmWoundQuestions: any[]): WmWoundQuestion[] {
    return wmWoundQuestions.map(_wmWoundQuestion => WmWoundQuestionFactory.fromObject(_wmWoundQuestion));
  }

}
